import React from 'react'

const BlogCardLoader = () => {
    return (
        <div className="w-full min-h-[480px] border rounded-lg flex flex-col justify-between max-w-md lg:max-w-none mx-auto animate-pulse">
            <div>
                <div className='w-full h-[230px] rounded-t-lg bg-gray-200'></div>
                <div className="flex flex-col items-start justify-center w-full text-left p-4">
                    <div className='flex gap-10 items-center mb-3'>
                        <div className="w-44 h-[20px] rounded-3xl bg-gray-200"></div>
                        <div className="w-20 h-[20px] rounded-3xl bg-gray-200"></div>
                    </div>
                    <div className='flex w-full flex-col gap-2'>
                        <div className="w-[90%] h-[20px] rounded-3xl bg-gray-200"></div>
                        <div className="w-[50%] h-[20px] rounded-3xl bg-gray-200"></div>
                    </div>

                    <div className="rounded-3xl mt-4 w-full h-[160px] bg-gray-200 flex flex-col gap-4"></div>
                </div>
            </div>
        </div>
    )
}

export const BlogLoader = () => (
    <div className="animate-pulse bg-gray-200 rounded-[20px] h-full w-full">

    </div>
)

export default BlogCardLoader